'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserProfile from 'MeetingsBase/models/UserProfile';
import Branding from 'MeetingsBase/models/Branding';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import UIFlex from 'UIComponents/layout/UIFlex';
import { getBookInfo as getBookInfoSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import { LINK_TYPES, MEETING_TYPES } from 'MeetingsBase/constants/enums';
import get from 'transmute/get';
import DatePicker from 'MeetingsLib/components/schedule/date/DatePicker';
import ProfileHeader from 'MeetingsLib/components/header/ProfileHeader';
import ColoredCard from 'MeetingsLib/components/decorative/ColoredCard';
import OpenPaidMeetingPrice from 'MeetingsLib/components/payments/OpenPaidMeetingPrice';
import { getDisplayAvatarOption } from 'MeetingsLib/utils/utils';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getPaymentLinkInfo, getPaidMeetingsAvailableSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getPaidMeetingPrice } from 'MeetingsLib/selectors/PaymentStatusSelectors';
import styled from 'styled-components';
const FormattedReactMessageWrapper = styled.div.withConfig({
  displayName: "DatePickerSection__FormattedReactMessageWrapper",
  componentId: "thuktj-0"
})(["font-size:18px;"]);

class DatePickerSection extends Component {
  render() {
    const {
      avatar,
      companyAvatar,
      displayAvatarOption,
      branding,
      compact,
      headline,
      profile,
      setEventDate,
      isSalesStarter,
      DatePickerMarker,
      TimePickerMarker,
      linkType,
      isPaidMeeting,
      paidMeetingInfo,
      paidMeetingPrice
    } = this.props;
    const isPersonal = linkType === LINK_TYPES.get(MEETING_TYPES.PERSONAL);
    const avatarUrl = getDisplayAvatarOption(displayAvatarOption, avatar, companyAvatar, isPersonal);
    return /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      children: [/*#__PURE__*/_jsxs(ColoredCard, {
        className: "date-picker-section m-bottom-0 flex-grow-1",
        cardSectionClassName: "m-bottom-0 p-x-0 p-y-4 flex-column flex-grow-1 justify-center",
        branding: branding,
        children: [/*#__PURE__*/_jsx(ProfileHeader, {
          avatar: avatarUrl,
          booked: false,
          headline: headline,
          profile: profile
        }), isPaidMeeting && compact && /*#__PURE__*/_jsx(FormattedReactMessageWrapper, {
          className: "center-block p-all-2",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "payments.priceHeader",
            options: {
              price: paidMeetingPrice === 0 ? /*#__PURE__*/_jsx(OpenPaidMeetingPrice, {
                currency: paidMeetingInfo.currency
              }) : /*#__PURE__*/_jsx(FormattedCurrency, {
                value: paidMeetingPrice,
                currencyCode: paidMeetingInfo.currency
              })
            }
          })
        }), /*#__PURE__*/_jsx(DatePicker, {
          compact: compact,
          profile: profile,
          branding: branding,
          setEventDate: setEventDate,
          DatePickerMarker: DatePickerMarker,
          TimePickerMarker: TimePickerMarker
        })]
      }), compact && !isSalesStarter && /*#__PURE__*/_jsx("div", {
        style: {
          height: 48,
          width: '100%',
          flexShrink: 0
        }
      })]
    });
  }

}

DatePickerSection.propTypes = {
  // passed
  avatar: PropTypes.string,
  companyAvatar: PropTypes.string,
  branding: PropTypes.instanceOf(Branding).isRequired,
  displayAvatarOption: PropTypes.string,
  compact: PropTypes.bool,
  linkType: PropTypes.string,
  headline: PropTypes.string,
  profile: PropTypes.instanceOf(UserProfile).isRequired,
  DatePickerMarker: PropTypes.func.isRequired,
  TimePickerMarker: PropTypes.func.isRequired,
  // loaded
  isSalesStarter: PropTypes.bool,
  setEventDate: PropTypes.func.isRequired,
  paidMeetingInfo: PropTypes.object,
  paidMeetingPrice: PropTypes.number,
  isPaidMeeting: PropTypes.bool.isRequired
};
export default connect(state => ({
  isSalesStarter: state.isSalesStarter,
  linkType: get('linkType', getBookInfoSelector(state)),
  paidMeetingPrice: getPaidMeetingPrice(state),
  paidMeetingInfo: getPaymentLinkInfo(state),
  isPaidMeeting: getPaidMeetingsAvailableSelector(state)
}), Object.assign({}, FormActions))(DatePickerSection);